<template>
    <div>
        <div id="seccionImprimir">
            <div>
                <p class="color1 text-2xl text-center">Evaluación de {{setEvaluacion.libro.nombrelibro}}</p>
                <vs-divider></vs-divider>
                <p class="mt-3"><b class="color1">Disponible: </b> {{ setEvaluacion.fecha_inicio }} - {{ setEvaluacion.fecha_fin }}</p>
                <div class="flex mt-2">
                    <span class="mr-3"><b class="color1">Puntos: </b> {{ setEvaluacion.puntaje }}</span>
                    <span><b class="color1">Límite de tiempo: </b> {{ setEvaluacion.tiempo }} minutos</span>
                </div>
                <p class="mt-5 color2 tamanio1">
                    <b>Comentario del Profesor/a:</b> {{ setEvaluacion.indicaciones }}
                </p>
                <vs-divider class="mt-3"></vs-divider>
                <div class="vx-row">
                    <div class="vx-col w-full mb-6">
                        <div class="vx-row" v-for="(item,key) in arrayQuestions" :key="key">
                            <div class="vx-col w-full mb-6">
                                <div class="flex bg1" style="justify-content: space-between;">
                                    <p class="bg1 titulo">Pregunta {{ key + 1 }}</p>
                                    <p class="bg1 titulo">{{ item.puntaje }} pts</p>
                                </div>
                                <p class="mt-5">{{ item.pregunta }}</p>
                                <!--imagen-->
                                <!-- <img v-if="item.url!='' && item.url!='null' && item.url!=null" :src="$data_book+'archivos/'+'preguntas'+'/'+item.url" class="img-responsive mt-5" width="200" height="200" style="border-radius: 5px;"> -->
                                <!--opciones-->
                                <vs-divider></vs-divider>
                                <!--pregunta abierta-->
                                <div v-if="item.id_tipo == idPreguntaAbierta">
                                    <!--INPUT-->
                                    <vs-input v-model="item.seleccionar" class="w-full mt-5" label="Respuesta" placeholder="Escribe tu respuesta aquí"></vs-input>
                                </div>
                                <!--pregunta columna-->
                                <div v-if="item.id_tipo == idPreguntaColumna">
                                    <table style="width: 100%;" v-if="item.opciones.length > 0">
                                        <tr>
                                            <th>{{ item.columna1 }}</th>
                                            <th >{{ item.columna2 }}</th>
                                        </tr>
                                        <tr v-for="(tr, indexitem) in item.opciones" :key="indexitem" >
                                            <td><b>{{ indexitem + 1 }}.</b> {{ tr.respuesta }}</td>
                                            <td style="background-color: #f6f6f6;width: 40%;">
                                                <v-select :options="item.respuestasColumna" :reduce="val => val" class="w-full my-1" v-model="tr.seleccionar" />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div v-else>
                                     <!--preguntas normales-->
                                    <ul class="leftx" v-for="(tr,key2) in item.opciones" :key="key2">
                                        <li class="my-2">
                                            <vs-radio :v-model="'pregunta'+item.id" :vs-name="'radios1'+tr.id_pregunta" :vs-value="tr.respuesta">{{ tr.respuesta }}</vs-radio>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <vs-divider></vs-divider>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import html2pdf from "html2pdf.js"
export default {
    data() {
        return{
            arrayQuestions:[],
            idPreguntaAbierta:7,
            idPreguntaColumna:5,
        }
    },
    props:{
        arrayPreguntas:{
            type:Array,
            default:function(){
                return []
            }
        },
        grupoSelect:{
            type:Number,
            default:0
        },
        setEvaluacion:{
            type:Object,
            default:function(){
                return {}
            }
        },
    },
    mounted(){
        let me = this;
        me.arrayQuestions   = me.arrayPreguntas
        //ejecutar despues de 2 segundos
        setTimeout(() => {
            me.ExportToDoc()
        }, 2000);
    },
    methods: {
        ExportToDoc(){
            let me = this;
            //export con id seccionImprimir de un div y configurar el pdf y que haya espacio en cada inicio de pagina
            var element = document.getElementById('seccionImprimir');
            html2pdf(element, {
                margin:       1,    
                filename:     'Reporte de evaluacion.pdf',
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { scale: 2 },
                jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
            });
            //NOTIFIFY
            me.$vs.notify({
                title: 'Exportado',
                text: 'Tu evaluación ha sido exportada',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                time: 3000
            })
            //emit para cerrar 
            me.$emit('changeExport',true)
        }
    }
}
</script>